import { render, staticRenderFns } from "./OpportunityActions.vue?vue&type=template&id=d066f132&scoped=true"
import script from "./OpportunityActions.vue?vue&type=script&lang=js"
export * from "./OpportunityActions.vue?vue&type=script&lang=js"
import style0 from "./OpportunityActions.vue?vue&type=style&index=0&id=d066f132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d066f132",
  null
  
)

export default component.exports